import axios from "axios";
import React, { useEffect, useState } from "react";
import Web3 from "web3";
import AlgosignerUtility from "./../apis/AlgosignerUtility";
import Navbar from "./Navbar";
import { ToastContainer, toast } from 'react-toastify';
import { Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import './OffsetCredits.css';

const isAndroid = /Android/i.test(navigator.userAgent);
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isMobile = isAndroid || isIOS;

var config = require("../../src/config/dev").default;

function OffsetCredits() {
    const ID = sessionStorage.getItem("metamaskId");
    let AlgoId = "";
    const [alertDisplayed, setAlertDisplayed] = useState(false);
    let [metamaskId, setMetamaskId] = useState([]);
    const [EPRnfts, setEPRNfts] = useState([]);
    const [NonEPRnfts, setNonEPRnfts] = useState([]);
    const [cbdcWalletId] = useState(localStorage.getItem("buyerCbdcWalletId") || "");
    const [loading, setLoading] = useState(true);
    let newArray = [];
    let tokenIDArray = [];

    useEffect(() => {
        const fetchData = async () => {
            // MetaMask auto-connect disabled — using Hyperledger Fabric, not Ethereum
            // await handleConfirmPurchaseClick();
            await fetchEPRNft();
            await fetchNft();
            setLoading(false);
        };
        fetchData();

        const fetchTransactions = async () => {
            try {
                await Promise.all(tokenIDArray.map(async (tokenId) => {
                    const response = await fetch(config.API_ENDPOINT + 'src/v1/eprAsset/eprnft/vieweprnft?token_id=' + encodeURIComponent(tokenId), {
                        method: "get",
                        headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") },
                    });
                    const result = await response.json();
                    console.log("viewnftres", result.data.result);
                }));
            } catch (error) {
                console.error("Error fetching transactions:", error);
            }
        };

        const fetchNft = async () => {
            await axios.get(config.API_ENDPOINT + 'src/v1/nftdetails', {
                headers: { 'X-Api-token': sessionStorage.getItem('traceChainAccessToken') },
            }).then(async (res) => {
                newArray = res.data.data.result;
                newArray.forEach(el => { el.assetType = "NonEprAsset"; });
                setNonEPRnfts(newArray);
            });
        };

        const fetchEPRNft = async () => {
            await axios.get(config.API_ENDPOINT + 'src/v1/eprnftdetails', {
                headers: { 'X-Api-Token': sessionStorage.getItem("traceChainAccessToken") },
            }).then((res) => {
                const EPRnftResult = res.data.data.result;
                EPRnftResult.forEach(el => { el.assetType = "EprAsset"; });
                setEPRNfts(EPRnftResult);
                EPRnftResult.forEach(t => tokenIDArray.push(t.tokenId));
            });
        };

        // MetaMask auto-connect disabled — using Hyperledger Fabric, not Ethereum
        // handleConfirmPurchaseClick();
        fetchEPRNft();
        fetchNft();
        fetchTransactions();
    }, []);

    const handleConfirmPurchaseClick = async () => {
        try {
            if (typeof window.ethereum !== "undefined") {
                const chainId = await window.ethereum.request({ method: "eth_chainId" });
                if (chainId !== "0x13882") return;
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                const web3 = new Web3(window.ethereum);
                const accounts = await web3.eth.getAccounts();
                const from = accounts[0];
                setMetamaskId(from);
                sessionStorage.setItem("metamaskId", from);
            } else {
                if (isMobile) {
                    window.location.href = `https://metamask.app.link/dapp/${window.location.hostname}`;
                    return;
                }
                if (!alertDisplayed) {
                    toast.error("Please install or refresh MetaMask.", { position: 'top-center', autoClose: 5000 });
                    setAlertDisplayed(true);
                }
            }
        } catch (error) {
            console.error("MetaMask error:", error);
        }
    };

    const checkwithAlgos = async () => {
        try {
            const connection = await AlgosignerUtility.checkAlgoSignerWallet1(true);
            AlgoId = connection;
            if (!connection) return;
        } catch (err) {
            console.log(err.message);
        }
    };

    const truncate = (str, front = 8, back = 6) => {
        if (!str) return "—";
        if (str.length <= front + back + 3) return str;
        return `${str.slice(0, front)}...${str.slice(-back)}`;
    };

    /* ── shared table header / row renderers ── */
    const TH = ({ children }) => <th className="oc-table-th">{children}</th>;

    const renderEPRRows = (nfts, ownerMatch) =>
        nfts.flatMap((nft) =>
            nft.nft_sale
                .filter(s => ownerMatch(s, nft) && s.burn_copies > 0)
                .map(s => (
                    <tr key={s._id} className="oc-table-row">
                        <td className="oc-table-td"><span className="oc-asset-name">{nft.assetName}</span></td>
                        <td className="oc-table-td">{nft.assetId}</td>
                        <td className="oc-table-td"><span className="oc-addr" title={nft.tokenId}>{truncate(nft.tokenId)}</span></td>
                        <td className="oc-table-td">{nft.no_of_copies} {nft.eprAssetUom}</td>
                        <td className="oc-table-td">
                            <span className="oc-offset-badge">&#10003; {s.burn_copies} {nft.eprAssetUom}</span>
                        </td>
                        <td className="oc-table-td">
                            {s.owner && !/^trc-cbdc-/i.test(s.owner)
                                ? <Link className="oc-addr" to={"https://www.oklink.com/amoy/address/" + s.owner} target="_blank" title={s.owner}>{truncate(s.owner)}</Link>
                                : <span className="oc-addr" title={s.owner}>{truncate(s.owner)}</span>
                            }
                        </td>
                    </tr>
                ))
        );

    const renderNonEPRRows = (nfts, ownerMatch) =>
        nfts.flatMap((nft) =>
            nft.nft_sale
                .filter(s => ownerMatch(s, nft) && s.burn_copies > 0)
                .map(s => (
                    <tr key={s._id} className="oc-table-row">
                        <td className="oc-table-td"><span className="oc-asset-name">{nft.assetName}</span></td>
                        <td className="oc-table-td">{nft.assetId}</td>
                        <td className="oc-table-td"><span className="oc-addr" title={nft.tokenId}>{truncate(nft.tokenId)}</span></td>
                        <td className="oc-table-td">{nft.no_of_copies} {nft.assetUom}</td>
                        <td className="oc-table-td">
                            <span className="oc-offset-badge">&#10003; {s.burn_copies} {nft.assetUom}</span>
                        </td>
                        <td className="oc-table-td">
                            {s.owner && !/^trc-cbdc-/i.test(s.owner)
                                ? <Link className="oc-addr" to={"https://www.oklink.com/amoy/address/" + s.owner} target="_blank" title={s.owner}>{truncate(s.owner)}</Link>
                                : <span className="oc-addr" title={s.owner}>{truncate(s.owner)}</span>
                            }
                        </td>
                    </tr>
                ))
        );

    const emptyRow = (cols = 6) => (
        <tr>
            <td colSpan={cols} style={{ padding: 0 }}>
                <div className="oc-empty">
                    <div className="oc-empty-icon">&#9634;</div>
                    No offset records found.
                </div>
            </td>
        </tr>
    );

    const tableHeaders = (ownerLabel) => (
        <thead>
            <tr>
                <th className="oc-table-th">Asset Name</th>
                <th className="oc-table-th">Asset ID</th>
                <th className="oc-table-th">Token ID</th>
                <th className="oc-table-th">Total Qty</th>
                <th className="oc-table-th">Offset Qty</th>
                <th className="oc-table-th">{ownerLabel}</th>
            </tr>
        </thead>
    );

    /* ── MetaMask filter helpers ── */
    const mmId = typeof metamaskId === 'string' ? metamaskId.toLowerCase() : "";
    const isMetaMaskOwner = (s) =>
        (s.owner === metamaskId || s.owner === mmId) &&
        !/^trc-cbdc-/i.test(s.owner || "");
    const isMetaMaskEPR = (s, nft) => isMetaMaskOwner(s) && nft.network_type !== "hyperledger";
    const isMetaMaskNonEPR = (s, nft) => isMetaMaskOwner(s) && nft.network_type !== "hyperledger";

    /* ── CBDC filter helpers ── */
    const isCbdcOwner = (s, nft) => {
        const isFabric = nft.network_type === "hyperledger" || /^trc-cbdc-/i.test(s.owner || "") || /^trc-test-/i.test(s.owner || "");
        return s.owner && s.owner.toLowerCase() === cbdcWalletId.toLowerCase() && isFabric;
    };

    return (
        <div className="oc-page">
            <Navbar />

            {/* ── Hero ── */}
            <div className="oc-hero">
                <div className="oc-hero-icon">&#9850;</div>
                <div className="oc-hero-text">
                    <h1>Offset Credits</h1>
                    <p>Track all your burned / offset NFT credits across Polygon and Hyperledger Fabric networks.</p>
                </div>
            </div>

            <div className="oc-content">

                {/* ── Wallet status banner ── */}
                {cbdcWalletId ? (
                    <div className="oc-wallet-banner cbdc">
                        <span className="oc-wallet-icon">&#128179;</span>
                        <span><b>CBDC Wallet Connected</b><span className="oc-wallet-addr">{cbdcWalletId}</span></span>
                    </div>
                ) : metamaskId ? (
                    <div className="oc-wallet-banner metamask">
                        <span className="oc-wallet-icon">&#129418;</span>
                        <span><b>MetaMask Connected</b><span className="oc-wallet-addr">{typeof metamaskId === 'string' ? metamaskId : ""}</span></span>
                    </div>
                ) : null}

                {/* ══ MetaMask / Polygon sections ══ */}
                {!cbdcWalletId && (
                    <>
                        {/* EPR */}
                        <div className="oc-section">
                            <div className="oc-section-header">
                                <span className="oc-sec-icon">&#127807;</span>
                                <h2>EPR Plastic Credits &mdash; Offset Records</h2>
                                <span className="oc-sec-badge">Polygon</span>
                            </div>
                            <div className="oc-table-wrap">
                                <table className="oc-table">
                                    {tableHeaders("Owner Address")}
                                    <tbody>
                                        {ID
                                            ? (() => { const rows = renderEPRRows(EPRnfts, isMetaMaskEPR); return rows.length ? rows : emptyRow(); })()
                                            : emptyRow()
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Non-EPR */}
                        <div className="oc-section">
                            <div className="oc-section-header">
                                <span className="oc-sec-icon">&#128230;</span>
                                <h2>Asset Credits &mdash; Offset Records</h2>
                                <span className="oc-sec-badge">Polygon</span>
                            </div>
                            <div className="oc-table-wrap">
                                <table className="oc-table">
                                    {tableHeaders("Owner Address")}
                                    <tbody>
                                        {ID
                                            ? (() => { const rows = renderNonEPRRows(NonEPRnfts, isMetaMaskNonEPR); return rows.length ? rows : emptyRow(); })()
                                            : emptyRow()
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )}

                {/* ══ CBDC / Hyperledger Fabric sections ══ */}
                {cbdcWalletId ? (
                    <>
                        {/* CBDC EPR */}
                        <div className="oc-section">
                            <div className="oc-section-header">
                                <span className="oc-sec-icon">&#127807;</span>
                                <h2>CBDC EPR Plastic Credits &mdash; Offset Records</h2>
                                <span className="oc-sec-badge">Hyperledger Fabric</span>
                            </div>
                            <div className="oc-table-wrap">
                                <table className="oc-table">
                                    {tableHeaders("Owner Wallet")}
                                    <tbody>
                                        {(() => { const rows = renderEPRRows(EPRnfts, isCbdcOwner); return rows.length ? rows : emptyRow(); })()}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* CBDC Non-EPR */}
                        <div className="oc-section">
                            <div className="oc-section-header">
                                <span className="oc-sec-icon">&#128230;</span>
                                <h2>CBDC Asset Credits &mdash; Offset Records</h2>
                                <span className="oc-sec-badge">Hyperledger Fabric</span>
                            </div>
                            <div className="oc-table-wrap">
                                <table className="oc-table">
                                    {tableHeaders("Owner Wallet")}
                                    <tbody>
                                        {(() => { const rows = renderNonEPRRows(NonEPRnfts, isCbdcOwner); return rows.length ? rows : emptyRow(); })()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                ) : (
                    !ID && (
                        <div className="oc-no-wallet">
                            <div className="oc-nw-icon">&#128274;</div>
                            <h3>No Wallet Connected</h3>
                            <p>Connect MetaMask or enter your CBDC Wallet ID on the asset purchase page to view your offset credits.</p>
                        </div>
                    )
                )}

            </div>
            <ToastContainer />
        </div>
    );
}

export default OffsetCredits;
